import React, { Dispatch, SetStateAction, useState } from 'react'
import { useSetAtom } from 'jotai'
import { isEmpty } from 'lodash-es'
import { PayActionBeneficiaryType, WalletActionType } from 'types/wallets'
import { TableSectionItem } from '../../types'
import { selectedFiatBeneficiaryAtom, selectedWalletAtom } from '../Pay/atoms/atoms'
import { WalletModalAction } from './WalletModalAction'

export interface PayMetadata {
  beneficiaryPaymentType: PayActionBeneficiaryType
  // BVNK Network
  beneficiaryOptionId?: string
  // Customer wallet payouts
  customerReference?: string
  customerWalletId?: string
}

export type WalletAction = {
  key: WalletActionType
  data?: TableSectionItem | { id?: string }
  metadata?: {
    pay?: PayMetadata
  }
}

export type WalletActionSharedProps = {
  walletId: string
  actionWalletId: string
  actionKey?: string
  setWalletId: Dispatch<SetStateAction<string>>
  onModalClose: () => void
}

interface ModalProps {
  action: WalletAction
  setWalletModalAction: Dispatch<SetStateAction<WalletAction>>
  refresh: () => void
  setShowWalletModal?: Dispatch<SetStateAction<boolean>>
}

export interface WalletTabProps {
  action: WalletAction
  walletId?: string
  setWalletId?: Dispatch<SetStateAction<string>>
  refresh: () => void
  step?: string
}

const WalletModal = ({ action, setWalletModalAction, refresh, setShowWalletModal }: ModalProps) => {
  // shared wallet id to persist selected wallet state across tabs
  const [walletId, setWalletId] = useState<string>()

  // Pay flow
  const setSelectedWalletAtom = useSetAtom(selectedWalletAtom)
  const setSelectedFiatBeneficiaryAtom = useSetAtom(selectedFiatBeneficiaryAtom)

  const cleanupPayAction = () => {
    setSelectedWalletAtom(null)
    setSelectedFiatBeneficiaryAtom(null)
  }

  // clear state on modal close
  const onModalClose = () => {
    setWalletModalAction(undefined)
    setWalletId(undefined)
    setShowWalletModal?.(false)

    // Pay flow cleanup
    cleanupPayAction()
  }

  if (isEmpty(action)) return <></>

  return (
    <WalletModalAction
      action={action}
      walletId={walletId}
      setWalletId={setWalletId}
      refresh={refresh}
      onModalClose={onModalClose}
    />
  )
}

export default WalletModal
